import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { Request } from '@shared/entities/request';
import { RequestFilter } from '@shared/entities/requestFilter';
import { FilterSelectedEventType } from '@shared/models/types';
import { RequestInfoFiltersService } from '@shared/services/api/request-info-filters.service';
import { RequestFilterURL, RequestInfoService } from '@shared/services/api/request-info.service';
import { Observable, of, switchMap, tap } from 'rxjs';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrl: './request.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _cdr = inject(ChangeDetectorRef);
  public translate = inject(TranslateService);
  private _themeService = inject(ThemeService);
  private _requestInfoService = inject(RequestInfoService);
  private _requestInfoFilterService = inject(RequestInfoFiltersService);

  isLight = true;
  requests$: Observable<Request[]>;
  requestFilter$: Observable<RequestFilter>;
  prevPage?: number = undefined;
  currentPage? = 1;
  nextPage?: number = undefined;
  totalPages?: number = undefined;

  constructor() {
    this.requests$ = this._requestInfoService.all$.pipe(
      switchMap((pagination) => {
        this.prevPage = pagination.prevPage;
        this.currentPage = pagination.currentPage;
        this.nextPage = pagination.nextPage;
        this.totalPages = pagination.totalPage;
        this._cdr.markForCheck();
        return of(pagination.data);
      })
    );

    this.requestFilter$ = this._requestInfoFilterService.all$;
  }

  ngOnInit() {
    this._themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => {
          this.isLight = x;
          this._cdr.markForCheck();
        })
      )
      .subscribe();
  }

  onSelectedFilter(filters: FilterSelectedEventType[]) {
    const filtersName = filters.reduce((acc: any, filter: FilterSelectedEventType) => {
      acc[filter.name] = filter.selectedValue;
      return acc;
    }, {});
    this._requestInfoFilterService.filters = filtersName as RequestFilterURL;
    this._requestInfoService.filters = filtersName as RequestFilterURL;
  }

  onClickPage(page: number) {
    this._requestInfoService.refresh(page);
  }
}
